import InfiniteListProvider from 'src/common/ui-kit/InfiniteList/InviteListContext'
import useAvailableBalance from '../../hooks/useAvailableBalance'
import useWalletTokens from '../../hooks/useWalletTokens'
import AssetList from '../AssetList/AssetList'
import { useMemo } from 'react'
import AssetListHeader from '../AssetList/AssetListHeader'
import AssetNoAccount from '../AssetList/AssetNoAccount'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'

type AssetGroup = 'crypto' | 'gold' | 'rwa' | 'all'

interface AssetManagementProps {
  group: AssetGroup
}

const AssetManagement: React.FC<AssetManagementProps> = ({ group = 'all' }) => {
  const { smartAccountInfo } = useSmartAccount()

  const {
    allTokens,
    goldTokens,
    cryptoTokens,
    rwaTokens,
    loading: walletTokensLoading,
  } = useWalletTokens()

  const { totalBalanceInUsd, loading: availableBalanceLoading } =
    useAvailableBalance()

  const loading = walletTokensLoading || availableBalanceLoading

  const tokensByGroup = useMemo(() => {
    switch (group) {
      case 'crypto':
        return cryptoTokens
      case 'gold':
        return goldTokens
      case 'rwa':
        return rwaTokens
      default:
        return allTokens
    }
  }, [allTokens, cryptoTokens, goldTokens, group, rwaTokens])

  return (
    <div>
      <AssetListHeader />
      {!smartAccountInfo ? (
        <AssetNoAccount />
      ) : (
        <InfiniteListProvider
          hasMore={false}
          loading={loading}
          loadMore={() => {}}
        >
          <AssetList
            assets={tokensByGroup}
            totalBalanceInUsd={totalBalanceInUsd}
          />
        </InfiniteListProvider>
      )}
    </div>
  )
}

export default AssetManagement
